import i18n from '../../../utilities/translation'
import GA4Handler from '../ga4_support/GA4Handler'
import { shuffle } from '../utilities'
import { refreshVisibleAds } from '../utilities/ad_behaviors'
import ga4RevealWidgetClickHandler from '../ga4_support/blocks/reveal_widget'

const language = document.documentElement.lang

const BASE_CLICK_TEXT = i18n('Tap to reveal the meme.', language)
export const BASE_REFRESH_TEXT = i18n('Tap to reveal another meme.', language)

const dateFormatter = (date: any) => {
  if (!date) return ''

  return new Intl.DateTimeFormat('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: '2-digit'
  }).format(date)
}

const currentDate = dateFormatter(new Date())
let displayCount = 0

const returnMemeArray = (newArray: any, contentArray: any) => {
  if (!newArray) return []

  contentArray.forEach((item: any) => {
    if (!item.endDate) {
      newArray.push(item)
    }
    if (item.startDate <= currentDate && currentDate <= item.endDate) {
      newArray.push(item)
    }
  })

  return newArray
}

export const initMemeBlock = (block: any, items: any) => {
  const memeArray: any = []
  let unseenContent: any = []
  let filteredItems: any = []

  unseenContent = shuffle(items)
  filteredItems = returnMemeArray(memeArray, unseenContent)

  const widgetContainers = [block]

  if (!widgetContainers.length) return

  widgetContainers.forEach(container => {
    let isRevealed = false

    GA4Handler.impressionHandleEvent(container as HTMLElement)

    const assign = (element: Element, selector: string) => {
      return element.querySelector(selector) as HTMLElement
    }

    // Init template
    const widgetInnerContainer: HTMLElement = assign(container, '.reveal-widget__inner-container')
    const widgetItem: HTMLElement = assign(container, '.memes-widget')
    const activeRegion: HTMLElement = assign(container, '.reveal-widget__dialog-region')
    const messageContainer: HTMLElement = assign(container, '.reveal-widget__message')
    const backgroundContainer: HTMLElement = assign(container, '.block--reveal-widget .block-item')
    const memePunchlineContainer: HTMLElement = assign(messageContainer, '.memes-widget--punchline')
    const shareButton: HTMLElement = assign(container, '.button__icon--share')
    const feedbackButton: HTMLElement = assign(container, '.button__icon--feedback')

    container.setAttribute('data-gtm-share-text', 'meme not revealed')
    container.setAttribute('data-gtm-feature', 'show')

    const returnBackgroundStyle = ({ url }, gradientFlag) => {
      const imageUrl = new Image()
      imageUrl.src = `${url}`

      if (
        gradientFlag &&
        document.querySelector('.memes-widget').classList.contains('reveal-widget--show-message')
      ) {
        backgroundContainer.setAttribute(
          'style',
          `background: linear-gradient(180deg, rgba(0, 0, 0, 0.0001) 61.38%, rgba(0, 0, 0, 0.1) 66.44%, #000000 92.19%),
            url(\n ${imageUrl.src});
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
            backface-visibility: hidden;
            transition: background-image .1s ease 0s;`
        )
        return
      }

      imageUrl.onload = () => {
        backgroundContainer.style.backgroundImage = "url('" + imageUrl.src + "')"
      }
    }

    const hideFeedbackButton = () => {
      feedbackButton.setAttribute('tabindex', '-1')
      feedbackButton.setAttribute('aria-hidden', 'true')
      feedbackButton.classList.add('hidden')
    }

    const showFeedbackButton = () => {
      feedbackButton.setAttribute('tabindex', '0')
      feedbackButton.removeAttribute('aria-hidden')
      feedbackButton.classList.remove('hidden')
    }

    const hideShareButton = () => {
      shareButton.setAttribute('tabindex', '-1')
      shareButton.setAttribute('aria-hidden', 'true')
      shareButton.classList.add('hidden')
    }

    const showShareButton = () => {
      shareButton.setAttribute('tabindex', '0')
      shareButton.removeAttribute('aria-hidden')
      shareButton.classList.remove('hidden')
    }

    const showMessage = ({ url }) => {
      widgetItem.classList.remove('reveal-widget--hide-message')
      widgetItem.classList.add('reveal-widget--show-message')
      container.setAttribute('data-gtm-feature', 'refresh')
      returnBackgroundStyle({ url }, true)
      showShareButton()
      showFeedbackButton()
    }

    const hideMessage = ({ url }) => {
      widgetItem.classList.remove('reveal-widget--show-message')
      widgetItem.classList.add('reveal-widget--hide-message')
      container.setAttribute('data-gtm-feature', 'show')
      container.setAttribute('data-gtm-share-text', 'meme not revealed')
      returnBackgroundStyle({ url }, false)
      hideShareButton()
      hideFeedbackButton()
    }

    const refreshJoke = ({ punchline, url }) => {
      truncateText(punchline)
      memePunchlineContainer.innerHTML = punchline
      container.setAttribute('data-mp-share-memes-text', `${BASE_REFRESH_TEXT} ${punchline}`)
      container.setAttribute('data-gtm-share-text', `${BASE_REFRESH_TEXT} ${punchline}`)
      returnBackgroundStyle({ url }, true)
    }

    const setClassList = (punchLineLength: any, clientViewPortWidth: any) => {
      if (clientViewPortWidth >= 320 && clientViewPortWidth < 360) {
        // 0-32
        if (punchLineLength > 1 && punchLineLength <= 32) {
          memePunchlineContainer.classList.add('max-character__38__320')
          memePunchlineContainer.classList.remove('max-character__48__320')
          memePunchlineContainer.classList.remove('max-character__62__320')
          memePunchlineContainer.classList.remove('max-character__85__320')
          memePunchlineContainer.classList.remove('max-character__140__320')
          return
        }

        // 33-42
        if (punchLineLength > 33 && punchLineLength < 43) {
          memePunchlineContainer.classList.remove('max-character__38__320')
          memePunchlineContainer.classList.add('max-character__48__320')
          memePunchlineContainer.classList.remove('max-character__62__320')
          memePunchlineContainer.classList.remove('max-character__85__320')
          memePunchlineContainer.classList.remove('max-character__140__320')
          return
        }

        // 43-60
        if (punchLineLength > 43 && punchLineLength < 60) {
          memePunchlineContainer.classList.remove('max-character__38__320')
          memePunchlineContainer.classList.remove('max-character__48__320')
          memePunchlineContainer.classList.add('max-character__62__320')
          memePunchlineContainer.classList.remove('max-character__85__320')
          memePunchlineContainer.classList.remove('max-character__140__320')
          return
        }

        // 61-75
        if (punchLineLength > 60 && punchLineLength < 75) {
          memePunchlineContainer.classList.remove('max-character__38__320')
          memePunchlineContainer.classList.remove('max-character__48__320')
          memePunchlineContainer.classList.remove('max-character__62__320')
          memePunchlineContainer.classList.add('max-character__85__320')
          memePunchlineContainer.classList.remove('max-character__140__320')
          return
        }

        // 76-140
        if (punchLineLength > 75 && punchLineLength < 140) {
          memePunchlineContainer.classList.remove('max-character__38__320')
          memePunchlineContainer.classList.remove('max-character__48__320')
          memePunchlineContainer.classList.remove('max-character__62__320')
          memePunchlineContainer.classList.remove('max-character__85__320')
          memePunchlineContainer.classList.add('max-character__140__320')
          return
        }
      }

      if (clientViewPortWidth >= 360 && clientViewPortWidth < 410) {
        // 0-32
        if (punchLineLength > 1 && punchLineLength <= 40) {
          memePunchlineContainer.classList.add('max-character__38__360')
          memePunchlineContainer.classList.remove('max-character__48__360')
          memePunchlineContainer.classList.remove('max-character__62__360')
          memePunchlineContainer.classList.remove('max-character__85__360')
          memePunchlineContainer.classList.remove('max-character__140__360')
          return
        }

        // 33-42
        if (punchLineLength > 40 && punchLineLength <= 52) {
          memePunchlineContainer.classList.remove('max-character__38__360')
          memePunchlineContainer.classList.add('max-character__48__360')
          memePunchlineContainer.classList.remove('max-character__62__360')
          memePunchlineContainer.classList.remove('max-character__85__360')
          memePunchlineContainer.classList.remove('max-character__140__360')
          return
        }

        // 43-60
        if (punchLineLength > 52 && punchLineLength <= 70) {
          memePunchlineContainer.classList.remove('max-character__38__360')
          memePunchlineContainer.classList.remove('max-character__48__360')
          memePunchlineContainer.classList.add('max-character__62__360')
          memePunchlineContainer.classList.remove('max-character__85__360')
          memePunchlineContainer.classList.remove('max-character__140__360')
          return
        }

        // 61-75
        if (punchLineLength > 70 && punchLineLength <= 80) {
          memePunchlineContainer.classList.remove('max-character__38__360')
          memePunchlineContainer.classList.remove('max-character__48__360')
          memePunchlineContainer.classList.remove('max-character__62__360')
          memePunchlineContainer.classList.add('max-character__85__360')
          memePunchlineContainer.classList.remove('max-character__140__360')
          return
        }

        // 76-140
        if (punchLineLength > 80 && punchLineLength < 142) {
          memePunchlineContainer.classList.remove('max-character__38__360')
          memePunchlineContainer.classList.remove('max-character__48__360')
          memePunchlineContainer.classList.remove('max-character__62__360')
          memePunchlineContainer.classList.remove('max-character__85__360')
          memePunchlineContainer.classList.add('max-character__140__360')
          return
        }
      }

      if (clientViewPortWidth > 410) {
        // 0-32
        if (punchLineLength > 1 && punchLineLength <= 52) {
          memePunchlineContainer.classList.add('max-character__38__412')
          memePunchlineContainer.classList.remove('max-character__48__412')
          memePunchlineContainer.classList.remove('max-character__62__412')
          memePunchlineContainer.classList.remove('max-character__85__412')
          memePunchlineContainer.classList.remove('max-character__140__412')
          return
        }

        // 33-42
        if (punchLineLength > 52 && punchLineLength <= 62) {
          memePunchlineContainer.classList.remove('max-character__38__412')
          memePunchlineContainer.classList.add('max-character__48__412')
          memePunchlineContainer.classList.remove('max-character__62__412')
          memePunchlineContainer.classList.remove('max-character__85__412')
          memePunchlineContainer.classList.remove('max-character__140__412')
          return
        }

        // 43-60
        if (punchLineLength > 62 && punchLineLength <= 80) {
          memePunchlineContainer.classList.remove('max-character__38__412')
          memePunchlineContainer.classList.remove('max-character__48__412')
          memePunchlineContainer.classList.add('max-character__62__412')
          memePunchlineContainer.classList.remove('max-character__85__412')
          memePunchlineContainer.classList.remove('max-character__140__412')
          return
        }

        // 61-75
        if (punchLineLength > 80 && punchLineLength <= 95) {
          memePunchlineContainer.classList.remove('max-character__38__412')
          memePunchlineContainer.classList.remove('max-character__48__412')
          memePunchlineContainer.classList.remove('max-character__62__412')
          memePunchlineContainer.classList.add('max-character__85__412')
          memePunchlineContainer.classList.remove('max-character__140__412')
          return
        }

        // 76-140
        if (punchLineLength > 95 && punchLineLength < 150) {
          memePunchlineContainer.classList.remove('max-character__38__412')
          memePunchlineContainer.classList.remove('max-character__48__412')
          memePunchlineContainer.classList.remove('max-character__62__412')
          memePunchlineContainer.classList.remove('max-character__85__412')
          memePunchlineContainer.classList.add('max-character__140__412')
          return
        }
      }
    }

    const truncateText = punchline => {
      if (!punchline) return

      const punchLineLength = punchline.length

      const clientViewPortWidth = document
        .querySelector('.reveal-widget__inner-container')
        .getBoundingClientRect().width

      setClassList(punchLineLength, clientViewPortWidth)
    }

    let isClickedOnce = false
    let activeMeme = filteredItems.pop()
    refreshJoke(activeMeme)

    /**
     * @todo Copy artifacts leftover here.
     */
    const refreshContent = () => {
      if (!isClickedOnce) {
        widgetInnerContainer.removeAttribute('aria-label')
        widgetInnerContainer.setAttribute('aria-labelledby', 'memes-widget__dialog-region')

        isClickedOnce = true
      }
      if (!isRevealed) {
        activeRegion.innerText = `${activeMeme.punchline}` + '\n\n' + BASE_REFRESH_TEXT
        showMessage(activeMeme)
        refreshVisibleAds()
        refreshJoke(activeMeme)
        container.setAttribute('data-gtm-feature', 'refresh')
        ga4RevealWidgetClickHandler(
          container,
          'editorial',
          'show',
          activeMeme.url,
          activeMeme.punchline,
          ++displayCount
        )
      } else {
        // Reset unseen fortunes if there are none left
        if (!filteredItems.length) {
          filteredItems = returnMemeArray(memeArray, unseenContent)
        }
        // Gets and removes last fortune to not repeat the same fortunes
        activeMeme = filteredItems.pop()
        hideMessage(activeMeme)
        refreshJoke(activeMeme)
        activeRegion.innerText = `\n\n ${BASE_CLICK_TEXT}`
        ga4RevealWidgetClickHandler(container, 'editorial', 'refresh', '', '')
      }
      isRevealed = !isRevealed
    }

    hideShareButton()
    hideFeedbackButton()
    widgetInnerContainer.addEventListener('click', refreshContent)
    widgetInnerContainer.addEventListener('keyup', (e: any) => {
      if (e.type !== 'keyup') {
        return
      }
      if (['Enter', ' '].includes((e as any).key)) {
        refreshContent()
      }
    })
  })
}
